


































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RoomServiceAPI } from "@/api/room-service/room-service-api";
import {
  IRoomServiceRequest,
  TRoomServicePriority,
  TRoomServiceType,
  TRoomServiceWakeUpMethod,
} from "@/@types/room-service/room-service";
import { IRoom } from "@/@types/hotel/room";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import RoomPicker from "./RoomPicker.vue";
import { isRoomServiceTypeHidden } from "@/services/featureConfig";

@Component({
  components: { RoomPicker },
})
class RequestCreateModal extends Vue {
  @Prop({ type: Boolean, default: false }) show!: boolean;

  loading = false;
  showPicker = false;

  serviceTypes: { value: TRoomServiceType; icon: string }[] = (
    [
      { value: "CONCIERGE_CALL", icon: "bell" },
      { value: "WAKE_UP", icon: "alarm" },
      { value: "HYGIENE_SUPPLIES", icon: "basket" },
      { value: "CLEANING_REQUEST", icon: "brush" },
      { value: "DO_NOT_DISTURB", icon: "moon-stars" },
      { value: "EMERGENCY_ASSISTANCE", icon: "exclamation-triangle-fill" },
    ] as { value: TRoomServiceType; icon: string }[]
  ).filter((opt) => !isRoomServiceTypeHidden(opt.value));

  priorities: TRoomServicePriority[] = ["LOW", "MEDIUM", "HIGH", "CRITICAL"];

  wakeUpMethods: TRoomServiceWakeUpMethod[] = [
    "PHONE_CALL",
    "PERSONAL_VISIT",
    "DEVICE_ALARM",
  ];
  wakeUpTime = "";
  wakeUpMethod: TRoomServiceWakeUpMethod = "PHONE_CALL";

  form = {
    serviceType: "CONCIERGE_CALL" as TRoomServiceType,
    room_number: "",
    vroom_id: "",
    guest_name: "",
    priority: "MEDIUM" as TRoomServicePriority,
    description: "",
  };

  @Watch("show")
  onShow(val: boolean): void {
    if (val) {
      this.showPicker = false;
      this.wakeUpTime = "";
      this.wakeUpMethod = "PHONE_CALL";
      this.form = {
        serviceType: "CONCIERGE_CALL",
        room_number: "",
        vroom_id: "",
        guest_name: "",
        priority: "MEDIUM",
        description: "",
      };
    }
  }

  onPickRoom(payload: { room: IRoom; vroom?: IVirtualRooma }): void {
    this.form.room_number = payload.room.name || "";
    this.form.vroom_id = payload.vroom?._id || "";
    this.showPicker = false;
  }

  get canSubmit(): boolean {
    if (!this.form.room_number) return false;
    if (this.form.serviceType === "WAKE_UP" && !this.wakeUpTime) return false;
    return true;
  }

  close(): void {
    this.$emit("close");
  }

  async submit(): Promise<void> {
    if (!this.canSubmit || this.loading) return;
    this.loading = true;
    const details: {
      description?: string;
      wakeUpTime?: Date;
      wakeUpMethod?: TRoomServiceWakeUpMethod;
    } = { description: this.form.description || undefined };

    if (this.form.serviceType === "WAKE_UP" && this.wakeUpTime) {
      const [h, m] = this.wakeUpTime.split(":").map(Number);
      const d = new Date();
      d.setHours(h || 0, m || 0, 0, 0);
      details.wakeUpTime = d;
      details.wakeUpMethod = this.wakeUpMethod;
    }

    const body: Partial<IRoomServiceRequest> & {
      guest_name?: string;
      details?: typeof details;
    } = {
      serviceType: this.form.serviceType,
      room_number: this.form.room_number,
      vroom_id: this.form.vroom_id,
      priority: this.form.priority,
      guest_name: this.form.guest_name || String(this.$t("roomService.guest")),
      details,
    };
    try {
      const res = await RoomServiceAPI.addForAdmin(
        body,
        this.form.vroom_id || undefined
      );
      if (res.status === 200 || res.status === 201) {
        this.$notify({
          group: "global",
          text: res.data.message || String(this.$i18n.t("alerts.save")),
          type: "success",
        });
        this.$emit("created", res.data.request);
        this.close();
      }
    } catch (e) {
      console.log(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    } finally {
      this.loading = false;
    }
  }
}
export default RequestCreateModal;
